<template>
  <Tooltip
    ref="mockupTooltip"
    :disabled="isMobile"
    trigger="click"
    :custom-position="{ top: '-60%', left: '100%', transform: 'translateX(-100%)' }"
  >
    <template #target>
      <button
        type="button"
        class="mockup-button__mockups-link"
        data-testid="transfers-view-larger-mockups"
        @click="openMockupModal"
      >
        View Larger Mockups
      </button>
    </template>
    <template #content>
      <MockupDisplay
        :artwork-url="artwork.manualEditUrl || artwork.url"
        :index="index"
        size="large"
        @close="closeMockupTooltip"
      />
    </template>
  </Tooltip>
  <CommonModal
    v-if="isMobile && isOpenMockupModal"
    ref="mockupModal"
    compact
    hide-close-button
    bottom-aligned
  >
    <MockupDisplay
      is-mobile
      :artwork-url="artwork.manualEditUrl || artwork.url"
      size="medium"
      @close="closeMockupModal"
    />
  </CommonModal>
</template>

<script setup>
import { ref, computed } from "vue";
import { isMediumDeviceAndUp } from "common/utils/browser";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import Tooltip from "common/vue/components/Tooltip.vue";
import CommonModal from "common/vue/components/CommonModal.vue";
import MockupDisplay from "./MockupDisplay.vue";
import { useDtfStore } from "../store";

const props = defineProps({
  index: {
    type: Number,
    required: true
  }
});

const isOpenMockupModal = ref(false);

const mockupModal = ref(null);
const mockupTooltip = ref(null);

const isMobile = !isMediumDeviceAndUp();

const store = useDtfStore();

const artwork = computed(() => store.artworks[props.index]);

const openMockupModal = () => {
  submitDtfEvent("preset_mockup_modal_opened", {
    artwork_id: artwork.value.id
  });
  if (isMobile) {
    isOpenMockupModal.value = true;
  }
};

const closeMockupModal = () => {
  mockupModal.value.close();
  isOpenMockupModal.value = false;
};

const closeMockupTooltip = () => {
  mockupTooltip.value.hideTooltip();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";

.mockup-button {
  &__mockups-link {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-decoration: underline;
    border: none;
    outline: none;
    background: none;
    color: $primary-600;
    cursor: pointer;
    margin-left: auto;
  }
}
</style>
